// Generated by ReScript, PLEASE EDIT WITH CARE


var min_name_char_length = 3;

var max_name_char_length = 50;

export {
  min_name_char_length ,
  max_name_char_length ,
}
/* No side effect */
